export default __webpack_public_path__ + "static/6-ae14691d36c254a9f0f484dd2e875e75.png";